
import { Mixin_list } from "@/mixin";
import { api_meal_record, meal_record } from "@/http/meal_record";
import { api_user, income } from "@/http/user";
import { Component } from "vue-property-decorator";
import Page from "@/components/page/index.vue";
import DatePicker from "@/components/datePicker/index.vue";
import Table from "@/components/table/index.vue";
import { api_store, store } from "@/http/store";
import PageHeader from "@/components/pageHeader/index.vue";

@Component({
  components: {
    Page,
    Table,
    DatePicker,
    PageHeader
  },
  
})

export default class extends Mixin_list<income>(api_user.get_incomeList) {
  filter = {
    user_id: this.id,
  };
  resetFilter = {
    ...this.filter,
  };
  columns = [
    {
      label: "ID",
      prop: "id",
      width: 80,
    },
    {
      label: "用户ID",
      prop: "user",
    },
    {
      label: "账户余额",
      prop: "balance",
    },
    // {
    //   label: "金额",
    //   prop: "price",
    // },
    {
      label: "金额",
      prop: "amount",
    },
    {
      label: "充值类型",
      slot: "price_type",
      prop: "price_type",
    },
    {
        label: "订单号",
        prop: "order_no",
    },
    {
      label: "消费备注",
      prop: "remark",
    },
    {
      label: "创建时间",
      prop: "create_time",
    },
  ];
  get id(): undefined | number {
    return this.$route.query.id as any;
  }
  // 获取头像
  get_avatar(value: string) {
    // 如果头像包含http，直接返回
    if (value.includes("http")) {
      return value;
    } else {
      return `https://images.xiyuebiaoju.com/${value}`;
    }
  }
  // 获取门店列表
  storeList: any[] = [];
  async get_store_list() {
    const res = await api_store.get_list({ page_size: 10000 });
    const list: any[] = [{ label: "全部", value: "" }];
    res.results.forEach((item: any) => {
      (item.value = item.id), (item.label = item.name);
    });
    this.storeList = list.concat(res.results);
  }
  reset() {
    this.filter = { ...this.filter, ...this.resetFilter };
    (this.$refs.datePicker as Vue & { clearDates: () => void }).clearDates();
    this.find();
  }
  created() {
    if (this.id === undefined) return;
    this.get_store_list();
  }
}
